import React  from 'react';
import { images } from '../../utils/constants/assets';
import { SOCIAL_LINKS } from '../../utils/constants/socialLinks';


interface StylistInfo {
  full_name?: string;
  facebook_handle?: string;
  instagram_handle?: string;
  tiktok_handle?: string;
}

interface SocialMediaLinksProps {
  stylistInfo?: StylistInfo;
  className?: string;
}

interface SocialMediaItem {
  id: number;
  handle?: string;
  isHandleAvailable: boolean;
  linkPrefix: string;
  icon: string;
}


const SocialMediaLinks: React.FC<SocialMediaLinksProps> = ({ stylistInfo, className = '' }) => {
  if (!stylistInfo) {
    return null;
  }

  const socialMediaData: SocialMediaItem[] = [
    {
      id: 1,
      handle: stylistInfo?.facebook_handle,
      isHandleAvailable: !!stylistInfo?.facebook_handle,
      linkPrefix: SOCIAL_LINKS.facebook,
      icon: images.fb_icon,
    },
    {
      id: 2,
      handle: stylistInfo?.instagram_handle,
      isHandleAvailable: !!stylistInfo?.instagram_handle,
      linkPrefix: SOCIAL_LINKS.instagram,
      icon: images.insta_icon,
    },
    {
      id: 3,
      handle: `@${stylistInfo?.tiktok_handle}`,
      isHandleAvailable: !!stylistInfo?.tiktok_handle,
      linkPrefix: SOCIAL_LINKS.tiktok,
      icon: images.tiktok_icon,
    },
  ];
  
  // Show available socials.
  const socialMediaLinks: SocialMediaItem[] = socialMediaData.filter(item => item.isHandleAvailable);
  if (socialMediaLinks.length === 0) {
    return null;
  }
  return (
    <div className={`service-summery need-assist follow-social ${className}`}>
      <span>Follow {stylistInfo?.full_name} socials</span>
      <ul className="social-links">
        {socialMediaLinks.map(
          ({ handle, linkPrefix, icon, id }) =>
            handle && (
              <li key={id}>
                <a href={`${linkPrefix}${handle}`} target="_blank" rel="noopener noreferrer">
                  <img src={icon} alt="" />
                </a>
              </li>
            )
        )}
      </ul>
    </div>
  );
};

export default SocialMediaLinks;
